<template>
  <div class="gridWrapper">
    <!-- <a @click="clearSearchPanel">reset</a> -->
    <!-- <div class="btn-wrapper py-2">
      <button type="button" @click="clearSearchPanel" class="btn btn-primary">
        <i class="fa fa-search-minus" aria-hidden="true"></i> Clear Search
      </button>
    </div> -->
    <DxDataGrid
      class="dataGridWrapper"
      id="BasicDataGrid"
      :ref="gridRefKey"
      :keyExpr="dataGridKey"
      :data-source="dataSource"
      :cache-enabled="true"
      @editing-start="setEditing(true)"
      @row-updated="setEditing(false)"
      :show-row-lines="showRowLines"
      @selection-changed="onSelectionChanged"
      :show-column-lines="showColumnLines"
      :row-alternation-enabled="alternateRowEnabled"
      :allow-column-resizing="true"
      :column-resizing-mode="columnResizingMode"
      :column-min-width="25"
      :remoteOperations="true"
      :on-cell-prepared="onCellPrepared"
      :on-row-prepared="onRowPrepared"
      :on-content-ready="onContentReady"
      :no-data-text="noDataText"
      width="100%"
      :height="height"
      :show-borders="true"
      :column-auto-width="false"
    >
      <DxExport :enabled="allowExport" />
      <DxSelection
        v-if="multiSelect"
        select-all-mode="allPages"
        show-check-boxes-mode="always"
        mode="multiple"
        maxWidth="25px"
      />
      <DxScrolling />
      <DxSearchPanel id="BasicDataGridSearch" :visible="searchEntireGrid"/>
      <DxFilterRow   :showOperationChooser="showColumnSearchIcon" :visible="searchByColumn"/>
      <DxHeaderFilter :visible="filterByColumn" />
      <DxFilterPanel :visible="advancedFilter"/>
      <DxStateStoring
        v-if="this.gridRef === 'orderSearchGrid'"
        :enabled="true"
        type="custom"
        storage-key="storage"
				:custom-save="orderSearchStateSave"
				:custom-load="orderSearchStateLoad"
      />
      <DxPaging :page-index="0" :page-size="itemsPerPage"/>
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="itemsPerPageOptions"
        :show-info="true"
        :visible="true"
      />
      <!-- <DxGroupPanel :visible="true"/>
      <DxGrouping :auto-expand-all="false"/> -->
      <DxEditing
        :allow-updating="allowEditing"
        mode="cell"
      />
      <DxColumnFixing :enabled="true"/>
      <DxColumn
          v-for="(column,index) in dataColumns"
          :key="index"
          :width="column.width"
          :max-width="column.maxWidth"
          :data-field="column.value"
          :data-type="column.dataType"
          :caption="column.text"
          :sort-order="column.sortOrder || undefined"
          :customize-text="column.customizeText || null"
          header-cell-template="title-header"
          cell-template="grid-cell"
      />

      <DxColumn
        v-if="iconActions.length"
        :min-width="75"
        :fixed="true"
        caption="Actions"
        type="buttons"
        alignment="right"
      >
        <DxButton v-for="(icon, index) in iconActions" :key="icon.hint + index"
					:text="icon.hint"
					:icon="icon.icon"
					:visible="icon.visible"
					:hint="icon.hint"
					:on-click="iconClickEmit" />
      </DxColumn>
      <template #title-header="{ data }">
        <div class="header" style="fontSize: 16px">{{ data.column.caption }}</div>
      </template>
      <template  #grid-cell="{ data }">
          <div class="cell" style="fontSize: 14px">
            <!-- Special handling for IsFavorite column -->
            <span v-if="data.column.dataField === 'IsFavorite'" @click.stop="$emit('toggleFavorite', { row: { data: data.data } })" style="cursor: pointer">
              <i :class="data.value ? 'fas fa-star' : 'far fa-star'"
                 :style="{color: data.value ? 'orange' : 'gray'}"></i>
            </span>
            <!-- Special handling for Status column -->
            <span v-else-if="data.column.dataField === 'IsDeleted'">
              <span v-if="$parent.shouldShowDeletedStatus">
                {{ data.data.IsDeleted ? 'Deleted' : 'Active' }}
              </span>
            </span>
            <!-- Default content for other columns -->
            <span v-else>{{ data.text }}</span>
          </div>
      </template>
    </DxDataGrid>
    <dx-tooltip :ref="tooltipRefName" position="top">
      <div class="tooltipContent">
        <div>{{currentCellToolTip}}</div>
      </div>
    </dx-tooltip>
  </div>
</template>
<script>

import DxDataGrid, { DxSelection, DxExport, DxEditing, DxScrolling, DxColumn, DxColumnFixing, DxFilterRow, DxSearchPanel, DxFilterPanel, DxHeaderFilter, DxPaging, DxPager, DxButton, DxStateStoring }       from 'devextreme-vue/data-grid';
import DxTooltip from "devextreme-vue/tooltip";
import { on, off } from "devextreme/events";
import { TableConfigService } from '../services';

const gridRefKey = 'data-grid';

export default {
  name: 'BasicDataGrid',
  props: {
    //Array of Objects containing the data used to populate the grid
    //Template: [{city: 'Atlanta', state: 'GA', phone: '(404)854-5859'}]
    dataSource:{
      type: [Object, Array],
      default:() => {}
    },
    dataGridKey: {
      type: String,
      default: 'Id'

    },

    //Headers used for mapping data to columns columns =[{text: 'Header Label', value: 'Column Value', width: '100px', dataType: 'Number'}], value should match datasource property
    columns:{
      type: Array,
      default:[]
    },
    showColumnSearchIcon: {
      type: Boolean,
      default: true,
    },
    gridRef: {
      type: String,
      default: 'Grid'
    },
    allowExport: {
      type: Boolean,
      default: false
    },
    showColumnLines:{
      type: Boolean,
      default: false
    },
    showRowLines:{
      type: Boolean,
      default: true
    },
    alternateRowEnabled:{
      type: Boolean,
      default: true
    },
    searchEntireGrid:{
      type: Boolean,
      default: true
    },
    searchByColumn: {
      type: Boolean,
      default: true
    },
    filterByColumn:{
      type: Boolean,
      default: true
    },
    advancedFilter:{
      type: Boolean,
      default: false
    },
    itemsPerPage:{
      type: Number,
      default: 50
    },
    itemsPerPageOptions:{
      type: Array,
      default: () => [50, 100, 200],
    },
    noDataText: {
      type: String,
      default: 'No Data Available'
    },
    //Options for ColumnResizing 'nextColumn' and 'widget'
    columnResizingMode: {
      type: String,
      default: 'widget'
    },
    multiSelect:{
      type: Boolean,
      default: true
    },
    // cellFontSize: {
    //   type: String,
    //   default: '12px'
    // },
    smartCatalogSearchGrid: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "600px"
    },
    // headerFontSize: {
    //   type: String,
    //   default: '16px'
    // },
    allowEditing: {
      type: Boolean,
      default: false
    },
    actions: {
      // Template: [{hint: 'Delete, icon: 'trash', emit: 'value you would like to emit'}] emit will return the event
      // must have a hint property to trigger emit events
      // For icon options visit:
      // https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/buttons/#icon
      // or for built in devExtreme icon Library
      // https://js.devexpress.com/Documentation/Guide/Themes_and_Styles/Icons/#Built-In_Icon_Library
      type: Array,
      default: () => [],

    },
    showFavoriteSeparator: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DxTooltip,
    DxDataGrid,
    DxColumn,
    DxColumnFixing,
    DxFilterRow,
    DxSearchPanel,
    DxFilterPanel,
    DxHeaderFilter,
    DxPaging,
    DxExport,
    DxPager,
    DxSelection,
    DxScrolling,
    DxEditing,
    DxButton,
    DxStateStoring
  },
  data() {
    return {
      currentCellToolTip: '',
      tooltipRefName: 'tooltip',
      iconActions: [],
      editing: false,
      selectedOrders: null,
      gridRefKey,
			dataColumns: [],
    };
  },
  methods: {
    clearSearchPanel(shouldEmit = true){
      this.dataGrid.clearFilter("search");
      this.dataGrid.clearFilter("row");
      if (shouldEmit) {
        this.$emit('clear-search')
      }
      sessionStorage.removeItem('orderSearchState')
    },
    onCellPrepared(e) {
      if (e.rowType === "header" && e.column.caption) {
        var self = this;
        on(e.cellElement, "mouseover", arg => {
            self.currentCellToolTip = e.column.caption;
            self.$refs[self.tooltipRefName].instance.show(arg.target);
        });
        on(e.cellElement, "mouseout", arg => {
          self.$refs[self.tooltipRefName].instance.hide();
        });
      }
      // Red text for deleted orders
      if (e.rowType === "data" && e.data.IsDeleted) {
        e.cellElement.classList.add('deleted-cell');
      }
    },
    onRowPrepared(e) {
      if (!this.showFavoriteSeparator) return;
      if (e.rowType === 'data') {
        e.rowElement.classList.remove('favorite-separator');
      }
    },
    onContentReady(e) {
      if (!this.showFavoriteSeparator) return;
      const rows = e.component.getVisibleRows();
      let lastFavoriteElement = null;
      for (const row of rows) {
        if (row.rowType === 'data' && row.data.IsFavorite) {
          const el = e.component.getRowElement(row.rowIndex);
          if (el && el[0]) lastFavoriteElement = el[0];
        }
      }
      if (lastFavoriteElement) {
        lastFavoriteElement.classList.add('favorite-separator');
      }
    },
    setEditing(bool){
      console.log(this);
      this.editing = bool;
    },
    onSelectionChanged(e){
      this.$emit('selectedRowsChanged', e.selectedRowsData)
    },
    iconClickEmit(e) {
      // event returned does not include specific action pressed, DevExtreme sets the target title to the hint value given.
      let actionIndex = this.iconActions.map(action => action.hint).indexOf(e.event.target.title)
      let emitterValue = this.iconActions[actionIndex].emit
      this.$emit(emitterValue, e)
    },
    productHasImage(e) {
        return e.row.data.ThumbnailURL;
    },
    productHasSmartCatalog(e) {
      return e.row.data.SmartCatalogMfgId
    },
		orderSearchStateSave(state) {
			//console.log('Got orderSearchStateSave', state);
			sessionStorage.setItem('orderSearchState', JSON.stringify(state));
		},
		stateSameAsConfig(state, config) {
			if (!state || !config) {
				return false;
			}

			if (state.columns.length-1 !== config.length) {
				return false;
			}

			for (let i = 0; i < state.columns.length-1; i++) {
				if (state.columns[i].dataField !== config[i].Field) {
					return false;
				}
			}

			return true;
		},
		async orderSearchStateLoad() {
			const state = sessionStorage.getItem('orderSearchState');
			let formattedState;
			if (state) {
				formattedState = JSON.parse(state);
			}

			const config = await TableConfigService.getConfig('OrderSearch');
      if (config?.Result?.Columns?.length > 0) {
        const sorted = config.Result.Columns.sort((a,b) => a.SortOrder - b.SortOrder);

				const isSame = this.stateSameAsConfig(formattedState, sorted);
				//console.log('isSame', isSame, formattedState, sorted)

				const columns = [];
        for (const col of sorted) {
          const columnDefinition = {
            text: col.Name,
            value: col.Field,
            dataType: col.DataType,
            width: col.Width
          };

					if (col.Field === 'CreatedOn') {
						columnDefinition.sortOrder = 'desc';
					}

					columns.push(columnDefinition);
				}

				this.dataColumns = columns;

				return isSame ? formattedState : null;
      }
			else {
				this.dataColumns = [
					{text: 'Order #', width: '150px', value: 'OrderNumber', dataType: "string"},
					{text: 'Order Date', width: '100px', value:'CreatedOn', dataType: "date", sortOrder: 'desc'},
					{text: 'Order Owner', width: '175px', value:'SalesRepFullName', dataType: "string"},
					{text: 'Worksheet Name', width: 'auto', value:'WorksheetName', dataType: "string"},
					{text: 'Customer #', width: '75px', value:'JdeNumber', dataType: "string"},
					{text: 'Bill Name', width: 'auto', value:'BillingInfo.Name', dataType: "string"},
					{text: 'Bill State', width: '75px', value:'BillingInfo.StateProvince', dataType: "string"},
					{text: 'Bill City', width: '75px', value:'BillingInfo.City', dataType: "string"},
					{text: 'Ship Name', width: '75px', value:'ShippingInfo.Name', dataType: "string"},
					{text: 'Ship State', width: '75px', value:'ShippingInfo.StateProvince', dataType: "string"},
					{text: 'Ship City', width: '75px', value:'ShippingInfo.City', dataType: "string"},
					{text: 'Install Date', width: '75px', value:'InstalledOn', dataType: "date"},
					{text: 'Revise Date', width: '75px', value:'RevisedOn', dataType: "date"},
					{text: 'Expire Date', width: '75px', value:'ExpiresOn', dataType: "date"}
				]

				return null;
			}
		}
    // onExporting(e) {
    //   const workbook = new ExcelJS.Workbook();
    //   const worksheet = workbook.addWorksheet('Main sheet');
    //   exportDataGrid({
    //     component: e.component,
    //     worksheet: worksheet,
    //     customizeCell: function(options) {
    //       const excelCell = options;
    //       excelCell.font = { name: 'Arial', size: 12 };
    //       excelCell.alignment = { horizontal: 'left' };
    //     }
    //   }).then(function() {
    //     workbook.xlsx.writeBuffer()
    //       .then(function(buffer) {
    //           saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
    //       });
    //   });
    //   e.cancel = true;
    // }
  },
  computed: {
    dataGrid: function() {
      // return this.$refs.gridRef.instance
      return this.$refs[gridRefKey].instance;
    }
  },
  watch: {
    columns: {
      handler(newColumns) {
        if (newColumns) {
          //console.log('BasicDataGrid columns updated:', newColumns);
          this.dataColumns = newColumns;
        }
      },
      immediate: true
    }
  },

  created(){
    // this.iconActions = ['edit']
    // console.log(this.$refs[page].instance);
    // console.log(this.gridRef);
    // this.gridSource = this.gridRef;
    // console.log(this.gridSource);

    if(this.actions.length > 0){
      this.actions.forEach(action => {
        this.iconActions.push({
          ...action,
          onClick: this.iconClickEmit
        })
      })
    }
    if(this.smartCatalogSearchGrid){
      this.iconActions.forEach((icon,index) => {
        if(icon.hint === 'image'){
          icon.visible = this.productHasImage
        }

        if(icon.hint === 'SmartCatalog') {
          icon.visible = this.productHasSmartCatalog
        }
      })
    }

  }
};
</script>
<style lang="scss" scoped>
  .gridWrapper {
    position: relative;
  }
  /* .button {
    position: absolute;
    right: 0;
    padding-bottom: 3px;
  } */
  .dataGridWrapper {
    position: absolute;
  }
  .header {
    color: $primary;
  }
  .cell {
    color: $ss_grey1;
  }
  .informer {
    height: 70px;
    width: 130px;
    text-align: center;
    color: #fff;
    padding: 500px;
  }
</style>

<style lang="scss">
  .dx-header-filter {
    color: rgb(51,122,183) !important;
  }

  .dx-header-filter-empty {
    color: rgba(149,149,149, 0.5) !important;
  }

  .dx-datagrid-search-panel input {
    padding-left: 10px !important;
  }

  .dx-searchbox .dx-icon-search {
    display: none !important;
  }

  .dx-searchbox .dx-placeholder {
    margin-left: -23px !important;
  }

  .favorite-separator {
    border-bottom: 3px solid #333 !important;
  }

  .deleted-cell .cell {
    color: rgb(180, 0, 0) !important;
  }
</style>